import { IUser } from "./user.types";

export enum TeamRole {
    TEAM_LEAD = "team_lead",
    AGENT = "agent",
}

export type TeamMember = {
    id: string;
    role: TeamRole | null;
    user?: IUser;
};

export type Team = {
    id: string;
    name: string;
    color: string;
    sortOrder: number;
    members: TeamMember[];
};

export type CreateTeamRequest = {
    name: string;
    color: string;
};

export type UpdateTeamRequest = {
    name?: string;
    color?: string;
    sortOrder?: number;
    members?: TeamMember[];
};
